import React, { Component } from "react"
import autobind from "class-autobind"
import { Tabs, Tab, CircularProgress } from "material-ui"
import { IAccountDocument, EPlanType, IClientDocument } from "../../../../models"
import * as accountActions from "../../../../actions/AccountActions"
import strings from "../../../../localization/strings"
import * as api from "../../../../api"
import AccountManagerClientTabClientDetails from "./AccountManagerClientTabClientDetails"
import AccountManagerClientTabFeatures from "./AccountManagerClientTabFeatures"
import AccountSubscription from "../../../../components/account/AccountSubscription"
import AccountManagerClientTabBilling from "./AccountManagerClientTabBilling"
import AccountManagerClientTabMarketing from "./AccountManagerClientTabMarketing"
import ExternalLink from "../../../common/externalLink/ExternalLink"
import * as permissionHelper from "../../../../helpers/permissionHelper"
import AuthenticationStore from "../../../../stores/AuthenticationStore"
import AppStateStore from "../../../../stores/AppStateStore"

interface IProps {
    accountId: string
    reloadData(): void
    closeDrawer(): void
}

interface IState {
    activeTab: string
    loading: boolean
    loadedAccount: IAccountDocument
    clientDoc: IClientDocument

}

export default class AccountManagerClientTabDrawerEditAccount extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props)
        this.state = {
            activeTab: "clientDetails",
            loading: true,
            loadedAccount: null,
            clientDoc: null
        }
        autobind(this)
    }

    componentDidMount(): void {
        this.getAccountDetails(this.props.accountId)
    }

    getAccountDetails(accountId: string) {
        this.setState({ loading: true }, () => {
            api.getAccountDetails(accountId).then(res => {
                const accountDoc = res.data as IAccountDocument
                api.getClientByExternalId(accountDoc.Id).then(response => {
                    const clientDoc: IClientDocument = response.data !== null ? response.data : { CompanyType: null, CompanySize: null }
                    this.setState({
                        loading: false,
                        loadedAccount: accountDoc,
                        clientDoc,
                    })
                })
            })
        })
    }

    updateLoadedAccount(loadedAccount: IAccountDocument): Promise<IAccountDocument> {
        return new Promise((resolve) => {
            this.setState({ loadedAccount }, () => resolve(this.state.loadedAccount))
        })
    }

    updateClientDoc(clientDoc: IClientDocument): void {
        this.setState({ clientDoc })
    }

    updateFeatures(feature: string, value: boolean) {
        if (this.state.loadedAccount.BillingInfo.PlanType !== EPlanType.Free) {
            if (feature === "schedule") {
                accountActions.updateScheduleFeature(this.state.loadedAccount.Id, value, true)
            } else if (feature === "timeoff") {
                accountActions.updateTimeoffFeature(this.state.loadedAccount.Id, value, true)
            }
        }
    }

    updatePlan(enableSchedule, enableTimeoff) {
        if (this.state.loadedAccount.BillingInfo.PlanType === EPlanType.Free) {
            accountActions.updateAccountPlan(this.state.loadedAccount.Id, EPlanType.Professional, enableSchedule, enableTimeoff, true)
        }
    }

    render() {
        const readOnly = !permissionHelper.hasAccountManagerPermission(AuthenticationStore.AccountManagerUserPermissions.Clients.EditAccountManagerClientDetails)
        return (
            this.state.loading ?
            <div>
                <div style={{ padding: 15, backgroundColor: AppStateStore.getFrontEndSettings().UISettings.AccentColor , height: 70 }}>
                    <h2 style={{ color: "#ffffff", textAlign: "center" }}>Loading Account Details...</h2>
                </div> 
                <div style={{ marginTop: "35%" }} className="spinner"><CircularProgress /></div>
            </div>
            :
            <div>
                <div style={{ padding: 15, backgroundColor: AppStateStore.getFrontEndSettings().UISettings.AccentColor , height: 70 }}>
                    <h2 style={{ color: "#ffffff" }}>
                        <span style={{ marginRight: 7 }}>
                            {this.state.loadedAccount.Name}
                        </span>
                        {permissionHelper.hasAccountManagerPermission(AuthenticationStore.AccountManagerUserPermissions.Clients.EnterClientAccount) &&
                            <ExternalLink
                                url={`/?proxy=${this.state.loadedAccount.Id}`}
                                iconColor="#ffffff"
                            />
                        }
                        <i className="fa fa-close itemActionButton" style={{ float: "right" }} onClick={() => this.props.closeDrawer()} />
                    </h2>
                </div>
                <Tabs
                    value={this.state.activeTab}
                    onChange={activeTab => this.setState({ activeTab })}
                >
                    <Tab label={strings.Client_Details} value="clientDetails">
                        {this.state.activeTab === "clientDetails" &&
                            <AccountManagerClientTabClientDetails
                                selectedAccount={this.state.loadedAccount}
                                reloadData={this.props.reloadData}
                                updateLoadedAccount={this.updateLoadedAccount}
                                clientDoc={this.state.clientDoc}
                                updateClientDoc={this.updateClientDoc}
                                readOnly={readOnly}
                            />
                        }
                    </Tab>
                    <Tab label={strings.Features} value="features">
                        {this.state.activeTab === "features" &&
                            <AccountManagerClientTabFeatures
                                account={this.state.loadedAccount}
                                updateLoadedAccount={this.updateLoadedAccount}
                                readOnly={readOnly}
                            />
                        }
                    </Tab>
                    <Tab label={strings.Billing} value="billing">
                        {this.state.activeTab === "billing" &&
                            <AccountManagerClientTabBilling
                                selectedAccount={this.state.loadedAccount}
                                updateLoadedAccount={this.updateLoadedAccount}
                                readOnly={readOnly}
                            />
                        }
                    </Tab>
                    <Tab label={strings.Plan} value="plan">
                        {this.state.activeTab === "plan" &&
                            <div style={{ padding: 20, overflow: "auto", height: "calc(100vh - 178px)" }}>
                                <AccountSubscription
                                    account={this.state.loadedAccount}
                                    updateFeatures={this.updateFeatures}
                                    updatePlan={this.updatePlan}
                                    readOnly={readOnly}
                                />
                            </div>
                        }
                    </Tab>
                    <Tab label={strings.Marketing} value="marketing">
                        {this.state.activeTab === "marketing" &&
                            <AccountManagerClientTabMarketing
                                clientDoc={this.state.clientDoc}
                                updateClientDoc={this.updateClientDoc}
                                readOnly={readOnly}
                            />
                        }
                    </Tab>
                    <Tab label={strings.PLG} value="plg">
                    </Tab>
                </Tabs>
            </div>
        )
    }
}